import React from "react";
import { useParams } from "react-router-dom";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ESRFieldProps } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";
import TextField from "@mui/material/TextField";

export const ESRDynamicSelectField = (props: ESRFieldProps) => {
	const { question_id, hint_value, locked, required } = props;
	const [value, setValue, setLocalValue] = useRemoteField(question_id);
	const [optionsStr] = useRemoteField(`${question_id}.OPTIONS`);
	let options: string[] = [];
	try {
		options = JSON.parse(optionsStr);
	} catch {}

	return options.length ? (
		<FormControl fullWidth>
			<InputLabel>Please select ONE value</InputLabel>
			<Select
				id={question_id}
				aria-labelledby={question_id}
				error={!value}
				disabled={locked > 0}
				value={value}
				label="Please select ONE value"
				onChange={(e) => setValue(e.target.value)}
			>
				{options.map((o) => {
					return (
						<MenuItem key={o} value={o}>
							{o}
						</MenuItem>
					);
				})}
			</Select>
		</FormControl>
	) : (
		<TextField
			id={question_id}
			fullWidth
			value={value}
			disabled={locked > 0}
			required={required}
			onChange={(e) => setLocalValue(e.target.value)}
			onBlur={(e) => setValue(e.target.value)}
			placeholder={hint_value.length > 0 ? hint_value : ""}
		></TextField>
	);
};
